<template>
	<div>
		<div class="row">
			<div class="columns small-12">
				<link-arrow 
					v-if="data.back_link" 
					:link="data.back_link" 
					direction="left" 
					:isDark="true"
					:text="$t('back_to_all_news')">
				</link-arrow>
				<block-title :blockTitle="data.title"></block-title>
			</div>
		</div>
		<div class="row">
			<div class="columns small-12 medium-11 large-8 ">
				<p class="published">{{ $t('published') }} {{ data.published_date }}</p>
				<div v-if="data.intro_before_photo" v-html="data.intro_before_photo"></div>
			</div>
			<div class="columns small-12 medium-11 large-9">
				<image-default v-if="data.photo" :image="data.photo" :caption="data.photo_caption" class="image-default"></image-default>
			</div>
			<div class="columns small-12 medium-8 large-8">
				<div v-if="data.post_content">
					<div v-for="(block, index) in data.post_content" :key="'news-content-' + index">
						<flexible-content-block-base :data="block" :folder="'global/parts'"></flexible-content-block-base>
					</div>
				</div>
			</div>

			<aside v-if="data.authors[0].name" class="columns small-12 medium-3 medium-offset-1 large-3 large-offset-1">
			
				<h3>{{ $t('authors') }}</h3>
				<ul class="not-a-list">
					<li v-for="(author, index) in data.authors" :key="'author-' + index">
						<h4 v-html="author.name"></h4>
						<h5 v-html="author.title"></h5>
						<dl>
							<dt class="screen-reader-only">{{ $t('phone') }}</dt>
							<dd v-html="author.phone_number"></dd>
						</dl>
					</li>
				</ul>
			</aside>
		</div>
	</div>
</template>

<script>

export default {
	props: ['data'],
	data() {
		return {
	
		}
	},
	components: {
		BlockTitle: () => import('@/components/global/parts/BlockTitle'),
		ImageDefault: () => import('dc-vue-default/src/components/global/parts/Image'),
		LinkArrow: () => import('dc-vue-default/src/components/global/ui/LinkArrow'),
		FlexibleContentBlockBase: () => import('dc-vue-default/src/components/FlexibleContentBlockBase'),
	}
}
</script>

<style lang="scss">
	@import "~@/styles/scss/component/news-single";
</style>